<ng-container *ngIf="pushStatus$ | async; let pushStatus">
  <ion-grid class="ion-padding">
    <ion-row>
      <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
        <ng-container [ngSwitch]="pushStatus">
          <ion-icon
            *ngSwitchCase="'accepted'"
            size="large"
            color="success"
            [src]="'bell-check-outline' | getIcon"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchCase="'just-accepted'"
            size="large"
            color="success"
            [src]="'bell-check-outline' | getIcon"
          >
          </ion-icon>

          <ion-icon *ngSwitchCase="'rejected'" size="large" [src]="'bell-remove-outline' | getIcon">
          </ion-icon>

          <ion-icon
            *ngSwitchCase="'need-permissions'"
            size="large"
            color="warning"
            [src]="'bell-ring-outline' | getIcon"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchCase="'unsupported'"
            size="large"
            color="medium"
            [src]="'bell-off-outline' | getIcon"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchCase="'error'"
            size="large"
            color="danger"
            [src]="'bell-remove-outline' | getIcon"
          >
          </ion-icon>

          <ion-icon *ngSwitchDefault size="large" [src]="'bell-off-outline' | getIcon"></ion-icon>
        </ng-container>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="ion-text-justify">
        <ng-container [ngSwitch]="true">
          <ion-text
            color="dark"
            *ngSwitchCase="pushStatus === 'accepted' || pushStatus === 'just-accepted'"
          >
            <p>
              La ricezione di notifiche push è abilitata. Riceverai delle notifiche su aggiornamenti
              nelle conversazioni via chat o di altri eventi in tempo reale!
            </p>

            <ng-container *ngTemplateOutlet="resetPushDescrTmpl"></ng-container>
          </ion-text>

          <ion-text color="dark" *ngSwitchCase="pushStatus === 'rejected'">
            <p>
              Non sono stati forniti i permessi per le notifiche o si è verificato un errore. Per
              cambiare impostazione, cliccare sulla prima icona (a forma di lucchetto 🔒 o punto
              informativo 🛈) all'inizio della barra degli indirizzi e riattivare le notifiche. Poi,
              ricaricare la pagina.
            </p>

            <img
              src="assets/messages/notif/address-bar.svg"
              height="56"
              alt="Descrizione posizione permessi nella barra degli indirizzi"
            />
          </ion-text>

          <ion-text color="dark" *ngSwitchCase="pushStatus === 'need-permissions'">
            <p>
              Per poter ricevere messaggi e notifiche in tempo reale è necessario accettare la
              ricezione delle notifiche.
            </p>
          </ion-text>

          <ion-text color="dark" *ngSwitchCase="pushStatus === 'unsupported'">
            <p>
              Questo browser non supporta la ricezione di notifiche push pertanto le conversazioni
              in chat potrebbero non essere aggiornate e potresti non ricevere eventi in tempo
              reale.
            </p>
          </ion-text>

          <ion-text color="dark" *ngSwitchCase="pushStatus === 'error'">
            <p>
              Si è verificato un errore. La ricezione di notifiche in tempo reale potrebbe non
              essere disponibile. Se vuoi provare a riabilitare la ricezione, clicca sul buttone
              sottostante.
            </p>

            <ng-container *ngTemplateOutlet="resetPushDescrTmpl"></ng-container>
          </ion-text>

          <ion-text color="dark" *ngSwitchDefault>
            <p>
              Non è possibile stabilire lo stato delle notifiche push. Potresti
              <strong>non</strong> ricevere aggiornamenti su chat o altri eventi in tempo reale.
            </p>
          </ion-text>
        </ng-container>
      </ion-col>
    </ion-row>

    <ion-row>
      <ng-container [ngSwitch]="true">
        <ion-col
          size="12"
          class="c3-flex ion-align-items-center ion-justify-content-center"
          *ngSwitchCase="
            pushStatus === 'accepted' || pushStatus === 'just-accepted' || pushStatus === 'rejected'
          "
        >
          <ng-container *ngTemplateOutlet="moreDetailsBtnTmpl"></ng-container>
        </ion-col>

        <ng-container *ngSwitchCase="pushStatus === 'need-permissions' || pushStatus === 'error'">
          <ion-col size="12" class="c3-flex ion-align-items-center ion-justify-content-center">
            <ion-button (click)="onRequestNotificationPermissions()" color="secondary">
              <span>Abilita Notifiche</span>
              <ion-icon slot="end" [src]="'bell-outline' | getIcon"></ion-icon>
            </ion-button>
          </ion-col>

          <ion-col size="12" class="c3-flex ion-align-items-center ion-justify-content-center">
            <ng-container *ngTemplateOutlet="moreDetailsBtnTmpl"></ng-container>
          </ion-col>
        </ng-container>
      </ng-container>
    </ion-row>
  </ion-grid>
</ng-container>

<ng-template #moreDetailsBtnTmpl>
  <ion-buttons>
    <ion-button (click)="openNotificationInfoDialog()" color="dark">
      <span>Maggiori Informazioni</span>
    </ion-button>
  </ion-buttons>
</ng-template>

<ng-template #resetPushDescrTmpl>
  <div class="app-margin-top">
    <h5>
      <ion-icon
        size="small"
        [src]="'message-cog-outline' | getIcon"
        class="ion-margin-end"
      ></ion-icon>
      <span>Reset permessi ricezione notifiche</span>
    </h5>
    <p>
      <small>
        Se pensi di <strong>non ricevere correttamente</strong> le notifiche in tempo reale, ti
        consigliamo di resettare il consenso all'invio delle notifiche:

        <ul>
          <li>
            Clicca sulla prima icona (a forma di lucchetto 🔒 o punto informativo 🛈) all'inizio
            della barra degli indirizzi

            <img
              src="assets/messages/notif/address-bar.svg"
              height="56"
              alt="Descrizione posizione permessi nella barra degli indirizzi"
            />
          </li>

          <li>Alla voce "Notifiche", scegli <strong>"default"</strong> dal menù a tendina</li>

          <li>Ricarica la pagina e dai nuovamente il consenso</li>
        </ul>
      </small>
    </p>
  </div>
</ng-template>
